import React, { Fragment, useEffect, useState } from 'react';

import SideNav from '../../Components/SideNav';
import FormularioAgregar from '../../Components/FormularioAgregar';
import FormularioEditar from '../../Components/FormularioEditar';
import View from './View';

import { useAuth } from '../../Context/Context';

import NoticiasHelper from '../../Helpers/Noticias';

const Noticias = () => {
    const { editar } = useAuth();

    const [noticia, setNoticia] = useState({
        imagen: ""
    });

    useEffect(() => {
        setNoticia(editar);
    }, [editar]);

    const leerDato = e => {
        setNoticia({
            ...noticia,
            [e.target.name]: e.target.value
        });
    };

    const agregarNoticia = e => {
        e.preventDefault();
        NoticiasHelper.agregarNoticia(noticia);
    };

    const actualizarNoticia = e => {
        e.preventDefault();
        NoticiasHelper.editarNoticia(noticia, editar._id);
    };

    return (
        <Fragment>
            <SideNav />
            <div className='row'>
                <FormularioAgregar>
                    <p className='titulo_1_admin'>Agregar noticia</p>

                    <form onSubmit={agregarNoticia}>
                        <div className="input-field">
                            <input onChange={leerDato} id="imagen" name='imagen' type="text" className="validate" />
                            <label htmlFor="imagen">URL de imagen</label>
                        </div>

                        <div className='botonn_1_admin' style={{ marginTop: "10px" }}>
                            <button type='submit'>
                                Agregar noticia
                            </button>
                        </div>
                    </form>
                </FormularioAgregar>
                <FormularioEditar>
                    <p className='titulo_1_admin'>Editar noticia</p>
                    <form onSubmit={actualizarNoticia}>
                        <div className="input-field">
                            <input onChange={leerDato} defaultValue={editar.imagen} id="imagen" name='imagen' type="text" className="validate" />
                            <label className='active' htmlFor="imagen">URL de imagen</label>
                        </div>

                        <div className='botonn_1_admin' style={{ marginTop: "10px" }}>
                            <button type='submit'>
                                Actualizar noticia
                            </button>
                        </div>
                    </form>
                </FormularioEditar>
                <View />
            </div>
        </Fragment>
    );
};

export default Noticias;
